declare var RestApi: any;

export class JSONPatch {
    private list: Operation[] = [];

    constructor() {
        this.list = [];
    }

    public add(operation: Operation): JSONPatch {
        this.list.push(operation);
        return this;
    }
}

// tslint:disable-next-line:max-classes-per-file
export class Operation {
    private op: string;
    private path: string;
    private value: any;

    constructor(path: string, value: any) {
        this.op = "replace";
        this.path = path;
        this.value = value;
    }
}

// tslint:disable-next-line:max-classes-per-file
export class RestDataLoader {
    public static loadData(url: string, parameters: any, consumer: (data: any) => any, onError: () => any,
                           withAuthentication = true) {
        if (url !== "") {
            RestApi.getJSON(url, parameters, consumer, onError, withAuthentication);
        }
    }

    public static async fetchData<T, R>({url, params, withAuthentication = true,}: {
        url: string,
        params: T,
        withAuthentication?: boolean
    }): Promise<R> {
        return await new Promise((resolve, reject) => {
            RestDataLoader.loadData(url, params, resolve, reject, withAuthentication)
        });
    }

    public static downloadSpreadsheet(
        url: string,
        parameters: any,
        consumer: (data: any) => any,
        onError: () => any,
        filename?: string,
    ) {
        const downloader = (data: any) => {
            const xhr = data as XMLHttpRequest;
            const blob = xhr.response;
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            if (filename) {
                a.setAttribute("download", filename);
            } else {
                a.toggleAttribute("download", true);
            }
            a.click();
            consumer(true);
        };
        if (url !== "") {
            RestApi.getSpreadsheet(url, parameters, downloader, onError);
        }
    }

    public static downloadSpreadsheetKeepingFileName(
        url: string,
        parameters: any,
        consumer: (data: any) => any,
        onError: () => any,
    ) {
        const downloader = (data: any) => {
            const xhr = data as XMLHttpRequest;
            const blob = xhr.response;
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            const fileNames = this.fileNameFromHeader(xhr.getResponseHeader("Content-Disposition"));
            a.download = fileNames.slice(1, fileNames.length - 1);
            $("body").append(a);

            a.click();
            consumer(true);
        };
        if (url !== "") {
            const request: XMLHttpRequest = RestApi.getSpreadsheet(
                url,
                parameters,
                downloader,
                onError,
            ) as XMLHttpRequest;
        }
    }


    public static downloadOctetStream(
        url: string,
        parameters: any,
        consumer: (data: any) => any,
        onError: () => any,
    ) {
        const downloader = (data: any) => {
            const xhr = data as XMLHttpRequest;
            const blob = xhr.response;
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            const fileNames = this.fileNameFromHeader(xhr.getResponseHeader("Content-Disposition"));
            a.download = fileNames.slice(1, fileNames.length - 1);
            $("body").append(a);
            a.click();
            consumer(true);
        };
        if (url !== "") {
            RestApi.getOctetStream(url, parameters, downloader, onError);
        }
    }

    public static postJSON(url: string, parameters: any, consumer: (data: any) => any, onError: () => any) {
        if (url !== "") {
            RestApi.postJSON(url, parameters, consumer, onError, true);
        }
    }

    public static patchJSON(url: string, parameters: any, consumer: (data: any) => any, onError: () => any) {
        if (url !== "") {
            RestApi.patchJSON(url, parameters, consumer, onError, true);
        }
    }

    public static putJSON(url: string, parameters: any, consumer: (data: any) => any, onError: (error?: any) => any) {
        if (url !== "") {
            RestApi.putJSON(url, parameters, consumer, onError, true);
        }
    }

    public static deleteJSON(url: string, parameters: any, consumer: (data: any) => any, onError: () => any) {
        if (url !== "") {
            RestApi.deleteJSON(url, parameters, consumer, onError, true);
        }
    }

    public static login(username: string, password: string, consumer: (data: any) => any, onError: () => any) {
        RestApi.login(username, password, consumer, onError);
    }

    public static getBaseUrl() {
        return RestApi.getBaseUrl();
    }

    public static fetchWithAuthentication(input: RequestInfo, authToken: string, init?: RequestInit) {
        return RestApi.fetchWithAuthentication(input, authToken, init);
    }

    public static protectedImageUrl(imageUrl: string, defaultImageUrl: string): Promise<string> {
        return RestApi.protectedImageUrl(imageUrl, defaultImageUrl);
    }

    public static getCurrentToken() {
        return RestApi.getCurrentToken();
    }

    public static arrayToUrlParams(paramName: string, array: string[]): string {
        return RestApi.arrayToUrlParams(paramName, array);
    }

    public static objToUrlParams(paramNames: string[], obj: any): string {
        return RestApi.objToUrlParams(paramNames, obj);
    }

    private static fileNameFromHeader(disposition): string {
        let result = null;
        if (disposition && /filename=.*/ig.test(disposition)) {
            result = disposition.match(/filename=.*/ig);
            return decodeURI(result[0].split("=")[1]);
        }
        return "";
    }
}
